import { render, staticRenderFns } from "./Que2.vue?vue&type=template&id=162d4ed4&scoped=true&"
import script from "./Que2.vue?vue&type=script&lang=js&"
export * from "./Que2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162d4ed4",
  null
  
)

export default component.exports